import script from "./onlyPeople.vue?vue&type=script&setup=true&lang=js"
export * from "./onlyPeople.vue?vue&type=script&setup=true&lang=js"

import "./onlyPeople.vue?vue&type=style&index=0&id=64c961f6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64c961f6"]])

export default __exports__